import React from 'react';
import PropTypes from 'prop-types';
import { Button as BtnAnt } from 'antd';

export default function Button(props) {
  const { children } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BtnAnt {...props}>
      {children}
    </BtnAnt>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.element
  ]),
  loading: PropTypes.bool,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  className: '',
  onClick: null,
  children: '',
  loading: false,
  disabled: false
};
